/** @jsxImportSource react */

const WizardPage = ({ Component = undefined, children, ...rest }) =>
  Component ? <Component {...rest} /> : children;

WizardPage.displayName = 'WizardPage';

export default WizardPage;
